import React from "react";
import "./frontend/FrontendLayout.css";
import { Header } from "./frontend";

const FrontendLayout = ({ children }) => {
  return (
    <div className="bg-tenken-gray-050">
      <Header />
      <main className="front-main-container">{children}</main>
    </div>
  );
};

export default FrontendLayout;
